export class ColorUtils {

  public static hexToRGBA(hex: string) {
    hex = hex.replace('#', '');
    if (hex.length === 3 || hex.length === 4) {
      hex = hex.split('').map(char => char + char).join('');
    }

    const r = parseInt(hex.substring(0, 2), 16);
    const g = parseInt(hex.substring(2, 4), 16);
    const b = parseInt(hex.substring(4, 6), 16);

    let a = 1;
    if (hex.length === 8) {
      a = parseFloat((parseInt(hex.substring(6, 8), 16) / 255).toFixed(2));
    }

    return { r, g, b, a };
  }
}

